import React, { useState } from "react";
import "../PayRebate/index.less";
import "./index.less";
import LogoPng from "../../assets/logo.png";
import type { RadioChangeEvent } from "antd";
import { Row, Radio, Space, Input, Button, message } from "antd";
import { useParams } from "react-router-dom";
import { post } from "../../axios/request";

export default function PayFeedback() {
  const isMobile = navigator.userAgent.indexOf("Mobile") > -1;
  const { kolId = "" } = useParams();

  const [radioValue, setRadioValue] = useState("");
  const [problemRemark, setProblemRemark] = useState("");

  // 问题描述修改
  const onChange = (e: RadioChangeEvent) => {
    setRadioValue(e.target.value);
    setProblemRemark("");
  };

  // 提交审核
  const handleSumbit = async () => {
    if (!radioValue) {
      message.error("请选择问题类型！");
      return;
    }
    if (radioValue === "其他" && !problemRemark) {
      message.error("请填写问题描述！");
      return;
    }
    const data = await post(
      `/patrick-star-api/kol-schedule-collected-rebate/kol-feedback/${kolId}?content=${
        radioValue === "其他" ? problemRemark : radioValue
      }`
    );
    if (data?.success) {
      message.success(
        "您的反馈已提交，我司将尽快安排工作人员处理，请留意企微群信息。"
      );
    } else {
      message.error(data.msg);
    }
    setRadioValue("");
    setProblemRemark("");
  };

  return (
    <div className={isMobile ? "container-mobile" : "container-pc"}>
      <div className="container">
        <div className={isMobile ? "" : "content-pc"}>
          <div className="content-feedback">
            {isMobile ? (
              <div className="company-logo">
                <img src={LogoPng} alt="" />
              </div>
            ) : (
              <div className="title">众引合作-返点支付</div>
            )}
            <Row justify="center">
              <div className={isMobile ? "" : "feedback-module"}>
                <div>
                  请选择您碰到的问题类型，便于我司工作人员尽快为您解决问题。
                </div>
                <div className="label">问题类型：</div>
                <Radio.Group onChange={onChange} value={radioValue}>
                  <Space direction="vertical">
                    <Radio value="我已支付">我已支付</Radio>
                    <Radio value="返点金额有误">返点金额有误</Radio>
                    <Radio value="其他">
                      <span>其他</span>
                      {radioValue === "其他" && (
                        <Input
                          placeholder="请输入问题描述有助于更快解决问题~"
                          style={{ width: "240px", marginLeft: "10px" }}
                          value={problemRemark}
                          onChange={(val) => {
                            setProblemRemark(val.target.value);
                          }}
                        />
                      )}
                    </Radio>
                  </Space>
                </Radio.Group>
                <Row justify="center" style={{ marginTop: "40px" }}>
                  <Button type="primary" onClick={handleSumbit}>
                    提交问题
                  </Button>
                </Row>
              </div>
            </Row>
          </div>
          {!isMobile && <img src={LogoPng} alt="" className="logo" />}
        </div>
      </div>
    </div>
  );
}
